// class for providing user authorization info (name, role, etc.)

import {Injectable} from "@angular/core";
import {IAuthorizeService, ROLE} from "libComm";
import {Observable, of} from "rxjs";
import {AuthService} from "../../services/auth.service";
import {map} from "rxjs/operators";
// import {OnInit} from "@angular/core";


@Injectable({
	providedIn: 'root'
})
export class EURAuthorizeService implements IAuthorizeService
{
	currRoleId: string;  // current role id
	roles: ROLE[];
	email: string;
	userName: string;

	constructor(private ddtas: AuthService)
	{
		this.roles = [];
		this.currRoleId = "role???";
		this.email = "???.???@???.??";
		this.userName = "username???";
	}

	// ngOnInit(): void
	// {
	// }

	// get user email
	getEmailObs(): Observable<string>
	{
		return this.ddtas.emailObs;
	}


	// get username
	getUserNameObs(): Observable<string>
	{
		return this.ddtas.nameObs;
	}

	// get all roles available for user
	getRolesObs(): Observable<ROLE[]>
	{
		return this.ddtas.getAvailableRole().pipe(
			map(values =>
				values.oContent.map(r => (
					{id: r.ROLE_ID, name: r.ROLE_NAME}
				))
			)
		);
	}

	// set roleId for current user
	setUserRoleObs(roleId: string): Observable<boolean>
	{
		return this.ddtas.setUserRole(roleId).pipe(
			map( result =>
			{
				// if ( result )
				// 	return true;
				// else
				// 	return false;
				return !!result;
			})
		);
	}

	// get user role
	getUserRoleObs(): Observable<string>
	{
		return this.ddtas.roleObs.pipe(
			map(value =>
				this.currRoleId = value
			)
		);
	}

	// invoked only after user role is changed successfully
	changeUserRoleHandler(): void
	{
		let reload: boolean = true;

		// clean some storage stuff
		localStorage.removeItem('layout');
		localStorage.removeItem('filter');

		Object.keys(sessionStorage).forEach(function (key)
		{
			if (!key.startsWith("sort"))
			{
				sessionStorage.removeItem(key)
			}
		});

		// DANGER: the following will cause window reloads and another call of ngOnInit() both on topbar and
		// 'custom-select', then 'custom-select' will emit 'onRoleChange' event again, that may cause
		// an infinite loop, depending on order values involved are initialized !!!
		window.location.reload();
	}
}